<template>
    <div>
        <v-row>
            <v-col cols="6">
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                        <th class="text-left pl-3">
                            User details
                        </th>
                        </thead>
                        <tbody>
                        <tr
                                v-for="[key, value] in Object.entries(userLogins)"
                                :key="key"
                        >
                            <td>{{key}}</td>
                            <td v-if="typeof value=== 'boolean'">
                                <v-checkbox :input-value="value" disabled></v-checkbox>
                            </td>
                            <td v-else>{{value}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
            <v-col cols="6">
                <thead>
                <th class="text-left pl-3">
                    Service events
                </th>
                </thead>
                <v-data-table
                        :headers="headers"
                        :items="eventLogs"
                        :items-per-page="10"

                >
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import constants from "../../constants";

    export default {
        name: "UserDetails",
        props: ['user'],
        data: () => ({
            userLogins: {},
            eventLogs: [],
            headers: [
                {
                    text: 'Service id',
                    align: 'start',
                    value: 'serviceId',
                },
                {text: 'Message', value: 'message'},
                {text: 'Event time', value: 'eventTime'}
            ],
        }),
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$http.get(constants.USER_DETAILS_ENDPOINT, {
                    params: {
                        accountId: this.user.id
                    }
                })
                    .then((response) => {
                        this.userLogins = Object.assign({}, this.user, response.data.userLogins)
                        this.eventLogs = response.data.eventLogs
                        console.log(this.eventLogs)
                    })
                    .catch(error => {
                        console.log(error)
                        //this.$log.error('Error in getting template ids: ', error)
                    });
            }
        }
    }
</script>

<style scoped>

</style>
